import styled from "styled-components";
import { Dropdown } from "antd";

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const StyledDropdownButton = styled(Dropdown.Button)`
  width: auto;
  min-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .ant-btn {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
